$(document).ready(function(){

  $('.pp_flavor_sel_card').click(function(evt){
    evt.preventDefault();
  });

  $('.pp_delivery_mode_sel').click(function(){
    $('.pp_delivery_mode_sel').removeClass('active');
    $(this).addClass('active');
    var mode = $(this).attr('data');
 
    if (mode == 'autodelivery'){
      var currentSellingPlan = $('.pp_form_sellingPlan_js').attr('data-selling-plan');
      $('.pp_form_sellingPlan_js').val(currentSellingPlan);
      $('.onlySubVisible').show();
      $('.pp_sub_content').show();
      $('.pp_onetime_content').hide();
      $('.pp_sub_box_select').trigger('change');
      $('.sub_price').show();
      $('.otp_price').hide();
    }
    else{
      $('.pp_form_sellingPlan_js').val('');
      $('.onlySubVisible').hide();
      $('.pp_sub_content').hide();
      $('.pp_onetime_content').show();
      $('.otp_price').show();
      $('.sub_price').hide();
      $('.pp_uk_quantity__js').val('1');
    }
  });

    $('.main-product__media').slick({
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        swipeToSlide: true,
        centerMode: true,
        arrows: true,
        fade: true,
        prevArrow: $(".main-product__left"),
        nextArrow: $(".main-product__right"),
        asNavFor: '.main-product__media-thumbnails' 
    });

    $('.main-product__media-thumbnails').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: true,
        centerMode: true,
        asNavFor: '.main-product__media', 
        variableWidth: true,
        focusOnSelect: true, 
        touchMove: true, 
        swipe: true, 
        draggable: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2, 
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.main-product__media-thumbnails').on('afterChange', function(event, slick, currentSlide){
        $('.main-product__media').slick('slickGoTo', currentSlide);
    });

    $('.main-product__media').on('afterChange', function(event, slick, currentSlide){
        $('.main-product__media-thumbnails').slick('slickGoTo', currentSlide);
    });

    $('.pdp_kodel_verta_carousel').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG_1.png?v=1724591972'/></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG.png?v=1724591971'/></button>",
  });

  $('.pdp_gift_variant_cel').click(function(){
    $('.pdp_gift_variant_cel').removeClass('active');
    $(this).addClass('active');

    var currentId = $(this).attr('data-id');
    $('.pdp_giftcard_id').attr('value', currentId);

    $('.pdp_As_price').hide();
    $('.pdp_As_price[data-id="'+currentId+'"]').show();
  });

  $('.pdp_as_sel').click(function(){
    
    $(this).closest('.pdp_as_selector').find('.pdp_as_sel').removeClass('active');
    $(this).addClass('active');

    var currentVal = $(this).attr('data');
    console.log(currentVal);
    $('.pdp_as_whole_content').hide();
    $('.pdp_as_whole_content[data="'+currentVal+'"]').show();

    $('.pdp_As_content').hide();
    $('.pdp_As_content[data="'+currentVal+'"]').show();
    var videoDesk = $('.Desktop_only .pdp_As_content[data="'+currentVal+'"]').find('video')[0];
    videoDesk.play();

    var videoMob = $('.Mobile_only .pdp_As_content[data="'+currentVal+'"]').find('video')[0];
    videoMob.play();


    var currentId = $(this).attr('data-id');
    $(this).closest('.pdp_meta_box').find('ppIdInput_js').val(currentId);


  });

  $('.pp_flavor_sel .pdp_as_sel').click(function(){
    var currentId = $(this).attr('data-id');
    var currentTitle = $(this).closest('.pp_flavor_sel_card').find('.pp_small_title').html();
    $('.main_title_for_product__js').html(currentTitle);

    $('.pp_uk_variant__js').val(currentId);
  });

 $('.pp_sub_box_select').change(function(){
  var currentVal = $(this).val();
  $('.pp_form_sellingPlan_js').val(currentVal);
  var currentOption = $(this).find('option:selected');
  var currentHTML = currentOption.html();
  console.log(currentHTML);

  // Extract both prices using regex
  var prices = currentHTML.match(/£(\d+\.\d+)/g);

  if (prices && prices.length >= 2) {
      var totalPrice = prices[0];  // Extract first price (total) with £
      var pricePerPc = prices[1];  // Extract second price (per piece) with £

      $('.sub_price').find('.pfu_mn_price').html(totalPrice);
      $('.sub_price').find('.pfu_pc_price').html(pricePerPc);
  }

  // Adjust quantity based on selected option
  if (currentVal == '689890853197'){
      $('.pp_uk_quantity__js').val('3');
  } else if (currentVal == '689890885965'){
      $('.pp_uk_quantity__js').val('6');
  }
});


  $('.pdp_gerio_kelione_carousel').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      centerMode: false,
      centerPadding: '100px',
      prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG_1.png?v=1724591972'/></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG.png?v=1724591971'/></button>",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            centerMode: false
          }
        },
        {
          breakpoint: 678,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false
          }
        }
      ]
  });

  $('.pdp_icons_line').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    pauseOnHover: false
});


  $('.pdp_accordion_line').click(function(){
    $(this).toggleClass('active');
    $(this).find('.pdp_accordion_info').slideToggle();
  });


  $('.pdp_qty_outer_block').click(function(){
    $('.pdp_qty_outer_block').removeClass('active');
    $(this).addClass('active');

    $('.pdp_qty_outer_block.active .pdp_select_qty_option__js').each(function(){
      var currentId = $(this).val();
      if (currentId == 'pasirink'){
        $(this).closest('.pdp_qty_expanded_main_product').addClass('needsAttention');
      }
    });

    if ($(this).attr('data') == 'fizinis'){
      $('.pdp_giftcard_type').attr('value', 'fizinis');
    }
    else{
      $('.pdp_giftcard_type').attr('value', 'elektroninis');
    }
    
  });

  $('.pdp_select_qty_option__js').change(function(){
    $('.pdp_qty_expanded_main_product').removeClass('needsAttention');
    $('.pdp_qty_outer_block.active .pdp_select_qty_option__js').each(function(){
      var currentId = $(this).val();
      if (currentId == 'pasirink'){
        $(this).closest('.pdp_qty_expanded_main_product').addClass('needsAttention');
      }
    });
  });

  $('.pdp_adding_to_cart_mn_btn').click(function(){
    var data = $('.pdp_qty_outer_block.active').attr('data');
    if ( data == '1'){
      $('.main_hidden_atc_btn_to_submit').trigger('click');
    }
    else {
      var items = [];

      $('.pdp_qty_outer_block.active .pdp_select_qty_option__js').each(function(){
        var currentId = $(this).val();
        items.push({ id: currentId, quantity: 1 });
      });
      

      $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: items,
          },
          dataType: "json",
          success: function (data) {
            $('.main_hidden_atc_btn_to_submit').trigger('click');
            
          },
        }); 

    }
  });
});